module.exports = __webpack_public_path__ + "static/media/chatbot-icon.96559373.png";